
import { defineComponent, ref, computed, reactive, toRefs,onMounted, onUpdated, inject } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  components: {
    
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Form',
    },
    data: {
      type: Object,
    },
    content: {
      type: String,
      default: 'Uploading and Sending Notification...'
    }
   
  },
  setup (props) {
    const form = ref<any>(props.data)
    const store = useStore()
    const items = ref([])
    const loading = ref(false)

    const setLoading = (payload: boolean) => {
      loading.value = payload
    }
    
    return {
      form,
      items,
      loading,
      setLoading
    }
  },
})
